import { DrawerFooter, ModalFooter } from '@cat-ecom/pcc-components';

type AssociatedDealerFooterProps = {
  isModal: boolean;
  children: React.ReactNode;
};

export const AssociatedDealerFooter = ({
  isModal,
  children
}: AssociatedDealerFooterProps) => {
  return (
    <>
      {isModal ? (
        <ModalFooter>{children}</ModalFooter>
      ) : (
        <DrawerFooter>{children}</DrawerFooter>
      )}
    </>
  );
};
